import { SET_BOOKINGS, GET_BOOKINGS } from './actionTypes'

export function setBookings(data) {
  return {
    type: SET_BOOKINGS,
    data,
  }
}

export function getBookingsSaga(data) {
  return {
    type: GET_BOOKINGS,
    data,
  }
}
